import { styled } from "@mui/material";
import { visuallyHidden } from "@mui/utils";

/**
 * Renders content that is hidden visually but remains available to assistive
 * technology. Used to convey status that is otherwise communicated only through
 * colour/iconography (WCAG 2.1 — 1.1.1 Non-text Content, 1.4.1 Use of Color).
 */
const VisuallyHidden = styled("span")(visuallyHidden as Record<string, unknown>);

export default VisuallyHidden;
